import { render, staticRenderFns } from "./LegacyModal.vue?vue&type=template&id=72b7832e&"
import script from "./LegacyModal.vue?vue&type=script&lang=js&"
export * from "./LegacyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports